// extracted by mini-css-extract-plugin
module.exports = {"BasicButton":"HndFL1iC-g+GKZNfwisCDQ==","OtherButton":"_79RXub1WiNO3Jbw7ECrXkA=="};